import {
  nextStepHandler,
  fundingApproval,
  getTaskForProjectConfirmation,
  getTaskForUnProjectConfirmation,
  launchTask,
  saveProcessDraft,
  getTaskBusinessData,
  dispatchTask,
  needHelpPerson,
  saveReturnDraft
} from '@/api/compositeAssit.js'
import store from '@/store'
import moment from 'moment'
import lodash from 'lodash'
function handleData(params = {}) {
  // formData
  const data = lodash.cloneDeep(params)
  let initData = {}
  if (data && data.pageType === 'launch') {
    console.log('拟稿发起')
    initData = lodash.cloneDeep(store.getters.initData)
  } else {
    initData = lodash.cloneDeep(store.getters.processData)
    console.log('重新发起')
  }
  const baseData = data.baseData
  const familyData = data.familyData
  const applyData = data.applyData
  const noticeReader = data.noticeReader
  const reviewData = data.reviewData
  const examineData = data.examineData
  // 项目申请时间
  applyData.individual_case_apply_time = applyData.individual_case_apply_time
    ? moment(applyData.individual_case_apply_time._d).format('YYYY-MM-DD')
    : ''
  initData.init_value.process_base_title = applyData.process_base_title // 项目title
  delete applyData.process_base_title // 将申请信息里的title字段删掉
  reviewData.review_time = reviewData.review_time
    ? moment(reviewData.review_time._d).format('YYYY-MM-DD')
    : ''
  examineData.examineForm_time = examineData.examineForm_time
    ? moment(examineData.examineForm_time._d).format('YYYY-MM-DD')
    : ''
  if (!data.assitPeopleInfoFlag) {
    // 当后台没有帮扶对象数据时，需要处理帮扶对象信息字段
    baseData.need_help_person_birthday = baseData.need_help_person_birthday
      ? moment(baseData.need_help_person_birthday).format('YYYY-MM-DD')
      : ''
    baseData.need_help_person_ensureDate = baseData.need_help_person_ensureDate
      ? moment(baseData.need_help_person_ensureDate._d).format('YYYY-MM-DD')
      : ''
  }
  initData.init_value.process_base_table_message = JSON.stringify(
    Object.assign(initData.init_value.process_base_table_message, {
      ...baseData,
      ...familyData,
      ...applyData,
      ...reviewData,
      ...examineData
    })
  )
  initData.process_config = data.leaderList
  initData.notice_reader = noticeReader
  return initData
}
function approvalData(approvalInfo = {}) {
  // 处理审批数据
  const initData = lodash.cloneDeep(store.getters.processData)
  initData.init_value = Object.assign({}, initData.init_value, {
    process_base_approval: approvalInfo.result === '同意' ? '1' : '0',
    process_base_approval_opinion: approvalInfo.opinion
  })
  initData.init_value.process_base_table_message = JSON.stringify(
    initData.init_value.process_base_table_message
  )
  return initData
}
export const service = {
  nextStepHandler(data) {
    // 查找下一步处理人
    let params = {}
    if (data && data.pageType === 'approval') {
      // 当是审批提交查找下一步处理人的时候
      console.log('审批查找下一步处理人')
      params = approvalData(data.approvalInfo)
    } else {
      // 草稿，拟稿，重新发起
      console.log('发起查找下一步处理人')
      params = handleData(data)
    }
    return new Promise((resolve, reject) => {
      nextStepHandler(params)
        .then((response) => {
          resolve(response)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  launchTask(data) {
    // 表单提交
    const params = handleData(data)
    return new Promise((resolve, reject) => {
      launchTask(params)
        .then((response) => {
          resolve(response)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  saveProcessDraft(data) {
    // 保存流程
    const params = handleData(data)
    return new Promise((resolve, reject) => {
      saveProcessDraft(params)
        .then((response) => {
          resolve(response)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  saveReturnDraft(data) {
    // 保存流程
    // const params = handleData(data)
    return new Promise((resolve, reject) => {
      saveReturnDraft(data)
        .then((response) => {
          resolve(response)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  getTaskBusinessData(data) {
    // 获取流程业务数据
    const params = handleData(data)
    return new Promise((resolve, reject) => {
      getTaskBusinessData(params)
        .then((response) => {
          resolve(response)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  dispatchTask(data) {
    // 处理表单
    let params = {}
    if (data.pageType === 'approval') {
      console.log('审批处理表单')
      params = approvalData(data.approvalInfo)
    } else {
      console.log('重新发起处理表单')
      params = handleData(data)
    }
    // initData.init_value.process_base_drafter = JSON.stringify(initData.init_value.process_base_drafter)
    return new Promise((resolve, reject) => {
      dispatchTask(params)
        .then((response) => {
          resolve(response)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  needHelpPerson(data) {
    // 获取帮扶对象数据
    return new Promise((resolve, reject) => {
      needHelpPerson(data)
        .then((response) => {
          resolve(response || [])
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  getTaskForProject(data) {
    // 获取帮扶对象项目关联
    return new Promise((resolve, reject) => {
      getTaskForProjectConfirmation(data)
        .then((response) => {
          if (response) {
            const data = lodash.cloneDeep(response || [])
            for (let i = 0; i < data.length; i++) {
              if (data[i].process_base_status) {
                if (data[i].process_base_status === 'Approval') {
                  data[i].process_status = '待审批'
                } else if (data[i].process_base_status === 'Draft') {
                  data[i].process_status = '申请中'
                } else if (data[i].process_base_status === 'Finish') {
                  data[i].process_status = '待发放'
                } else if (data[i].process_base_status === 'ReturnDraft') {
                  data[i].process_status = '退回（申请中）'
                } else if (data[i].process_base_status === 'Termination') {
                  data[i].process_status = '终止'
                } else if (data[i].process_base_status === 'IsFinished') {
                  data[i].process_status = '待发放'
                } else if (data[i].process_base_status === 'Finished') {
                  data[i].process_status = '已完成'
                }
              }
              // if (data[i].process_base_table_message) {
              //   data[i].process_base_table_message = JSON.parse(data[i].process_base_table_message)
              //   data[i].project_status = data[i].process_base_table_message.project_status ? data[i].process_base_table_message.project_status[0] : ''
              // }
            }
            resolve(data)
          } else {
            resolve([])
          }
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  getTaskForUnProject(data) {
    // 获取帮扶对象任务
    return new Promise((resolve, reject) => {
      getTaskForUnProjectConfirmation(data)
        .then((response) => {
          if (response) {
            const data = lodash.cloneDeep(response || [])
            for (let i = 0; i < data.length; i++) {
              data[i].time = data[i].process_base_draft_date
              if (data[i].process_base_status) {
                if (data[i].process_base_status === 'Approval') {
                    if ((data[i].process_config_step === 'street' && data[i].process_base_status_bit === 0) ||
                        (data[i].process_config_step === 'Draft' && data[i].process_base_status_bit === 1)) {
                        data[i].process_status = '待审批(街镇)'
                    }
                    if ((data[i].process_config_step === 'street' && data[i].process_base_status_bit === 1) ||
                        (data[i].process_config_step === 'districtAndCounty' && data[i].process_base_status_bit === 0)) {
                        data[i].process_status = '待审批(区级)'
                    }
                } else if (data[i].process_base_status === 'Draft') {
                  data[i].process_status = '申请中'
                } else if (data[i].process_base_status === 'Finish') {
                  data[i].process_status = '待发放'
                } else if (data[i].process_base_status === 'ReturnDraft') {
                  data[i].process_status = '退回（申请中）'
                } else if (data[i].process_base_status === 'Termination') {
                  data[i].process_status = '终止'
                } else if (data[i].process_base_status === 'IsFinished') {
                  data[i].process_status = '待发放'
                } else if (data[i].process_base_status === 'Finished') {
                  data[i].process_status = '已完成'
                }
              }
              if (data[i].process_config_type) {
                if (data[i].process_config_type === 'releaseOfFunds') {
                  data[i].process_type = '资金帮扶'
                } else if (data[i].process_config_type === 'activityConfirmation') {
                  data[i].process_type = '活动帮扶'
                } else if (data[i].process_config_type === 'individualCase') {
                  data[i].process_type = '个案帮扶'
                } else if (data[i].process_config_type === 'ghReleaseOfFunds') {
                  data[i].process_type = '资金帮扶-帮侬一把'
                } else if (data[i].process_config_type === 'ghActivityConfirmation') {
                  data[i].process_type = '活动帮扶-帮侬一把'
                } else if (data[i].process_config_type === 'internalDocuments') {
                  data[i].process_type = '内部文件'
                }
              }
            }
            resolve(data)
          } else {
            resolve([])
          }
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  fundingApproval(type, grantFormData) {
    // 获取帮扶对象数据
    return new Promise((resolve, reject) => {
      const initData = lodash.cloneDeep(store.getters.processData)
      const approval = 1
      initData.init_value.process_base_table_message = JSON.stringify({
        ...initData.init_value.process_base_table_message,
        ...grantFormData
      })
      initData.init_value.process_base_approval = approval
      fundingApproval(initData)
        .then((response) => {
          resolve(response)
        })
        .catch((err) => {
          reject(err)
        })
    })
  }
}
